module.exports = "https://trybtryb-legacy.web.app/img/message-balloons.21b2a910.svg";